export const getOptionField = (option, key) => {
  const isObject = typeof option === "object" && option !== null;
  return isObject ? option?.[key] : option;
};

export const getOptionValueCommon = (option) => {
  return getOptionField(option, "value");
};

export const getOptionLabelCommon = (option) => {
  return getOptionField(option, "label");
};

export const filterOption = (input, option) => {
  if (!input) return true;

  const searchText = input.toLowerCase();
  const label = (option.label || "").toString().toLowerCase();
  const value = (option.value || "").toString().toLowerCase();

  return label.includes(searchText) || value.includes(searchText);
};
